(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_14c4abc"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('aipo-product-overview')) return;

    var MONEY_FORMATS = {
      amount: [2, ',', '.'],
      amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_apostrophe_separator: [2, "'", '.']
    };

    var REVIEW_SELECTORS = [
      '#judgeme_product_reviews', '#judgeme_reviews', '.jdgm-widget', '.jdgm-rev-widg',
      '[id*="judgeme" i]', '[class*="judgeme" i]', '[id*="AppReviewsjudgeme" i]', '[id*="jdgm" i]'
    ];

    function esc(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    class AipoProductOverview extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        var d = this.dataset;
        this.moneyFormat = d.moneyFormat || '';
        this.tiersEnabled = d.tiersEnabled === 'true';
        this.daysPerUnit = parseInt(d.daysPerUnit, 10) || 30;
        this.showPerDay = d.showPerDay === 'true';
        this.perDayLabel = d.perDayLabel || 'day';

        this.mainImage = this.querySelector('[data-main-image]');
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-dot]'));
        this.priceEl = this.querySelector('[data-price]');
        this.atcBtn = this.querySelector('[data-add-to-cart]');
        this.atcLabel = this.querySelector('[data-atc-label]');
        this.atcPriceEl = this.querySelector('[data-atc-price]');
        this.atcPerDayEl = this.querySelector('[data-atc-per-day]');
        this.qtyInput = this.querySelector('[data-qty-input]');
        this.tierList = this.querySelector('[data-tier-list]');
        this.zoom = this.querySelector('[data-zoom]');
        this.zoomImage = this.querySelector('[data-zoom-image]');
        this.cartOverlay = this.querySelector('[data-cart-overlay]');
        this.cartBody = this.querySelector('[data-cart-body]');
        this.cartSubtotal = this.querySelector('[data-cart-subtotal]');

        this.index = 0;
        this.warmed = {};
        this.quantity = 1;
        this.cartQty = 1;
        this.variantId = null;
        this.tierPrice = NaN;
        this.tierAvailable = true;
        this.discount = 0;
        this.totalDays = this.daysPerUnit;
        this.basePrice = this.priceEl ? parseInt(this.priceEl.dataset.basePrice, 10) || 0 : 0;

        var selected = this.tierList && this.tierList.querySelector('[data-tier-option].selected');
        if (this.tiersEnabled && selected) this.readTier(selected);

        this.onEsc = this.onEsc.bind(this);
        this.addEventListener('click', this);
        this.addEventListener('keydown', this);

        if (this.mainImage && this.dots.length > 1) {
          var startX = 0;
          this.mainImage.addEventListener('touchstart', function (e) { startX = e.changedTouches[0].screenX; }, { passive: true });
          this.mainImage.addEventListener('touchend', function (e) {
            var dx = e.changedTouches[0].screenX - startX;
            if (Math.abs(dx) > 50) this.goTo(this.index + (dx < 0 ? 1 : -1));
          }.bind(this), { passive: true });
        }

        this.updatePrice();

        this.checkReadMore = this.checkReadMore.bind(this);
        this.checkReadMore();
        window.addEventListener('resize', this.checkReadMore, { passive: true });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.checkReadMore);
      }

      disconnectedCallback() {
        if (this.checkReadMore) window.removeEventListener('resize', this.checkReadMore);
      }

      handleEvent(e) {
        if (e.type === 'click') this.onClick(e);
        else if (e.type === 'keydown' && (e.key === 'Enter' || e.key === ' ') && e.target.closest('[data-rating]')) {
          e.preventDefault();
          this.scrollToReviews(e);
        }
      }

      onClick(e) {
        var t = e.target;
        var el;
        if ((el = t.closest('[data-dot]'))) return this.goTo(parseInt(el.dataset.index, 10));
        if (t.closest('[data-prev]')) return this.goTo(this.index - 1);
        if (t.closest('[data-next]')) return this.goTo(this.index + 1);
        if (t.closest('[data-main-image]')) return this.openZoom();
        if (t.closest('[data-zoom-close]') || t === this.zoom) return this.closeZoom();
        if ((el = t.closest('[data-readmore]'))) return this.toggleReadMore(el);
        if ((el = t.closest('[data-tab]'))) return this.selectTab(el);
        if ((el = t.closest('[data-tier-option]'))) return this.selectTier(el);
        if (t.closest('[data-qty-decrease]')) return this.step(-1);
        if (t.closest('[data-qty-increase]')) return this.step(1);
        if (t.closest('[data-add-to-cart]')) return this.addToCart(e);
        if (t.closest('[data-cart-close]') || t === this.cartOverlay) return this.closeCart();
        if (t.closest('[data-rating]')) return this.scrollToReviews(e);
      }

      /* ---------- Gallery ---------- */

      goTo(i) {
        var n = this.dots.length;
        if (!n || !this.mainImage) return;
        i = ((i % n) + n) % n;
        var dot = this.dots[i];
        this.index = i;
        if (dot.dataset.srcset) this.mainImage.srcset = dot.dataset.srcset;
        this.mainImage.src = dot.dataset.src;
        this.mainImage.alt = dot.dataset.alt || '';
        this.mainImage.dataset.zoomSrc = dot.dataset.zoom;
        this.dots.forEach(function (d, k) { d.classList.toggle('active', k === i); });
        this.warm(i + 1);
      }

      warm(i) {
        var n = this.dots.length;
        if (!n) return;
        i = ((i % n) + n) % n;
        if (this.warmed[i]) return;
        this.warmed[i] = true;
        var dot = this.dots[i];
        var img = new Image();
        img.sizes = this.mainImage.sizes;
        if (dot.dataset.srcset) img.srcset = dot.dataset.srcset;
        img.src = dot.dataset.src;
      }

      openZoom() {
        if (!this.zoom || !this.mainImage) return;
        this.zoomImage.src = this.mainImage.dataset.zoomSrc || this.mainImage.currentSrc || this.mainImage.src;
        this.zoomImage.alt = this.mainImage.alt;
        this.zoom.classList.add('active');
        this.lock();
      }

      closeZoom() {
        if (!this.zoom || !this.zoom.classList.contains('active')) return;
        this.zoom.classList.remove('active');
        this.unlock();
      }

      /* ---------- Tabs ---------- */

      selectTab(tab) {
        var name = tab.dataset.tab;
        this.querySelectorAll('[data-tab]').forEach(function (t) { t.classList.toggle('active', t === tab); });
        this.querySelectorAll('[data-content]').forEach(function (c) { c.classList.toggle('active', c.dataset.content === name); });
        this.checkReadMore();
      }

      /* ---------- Read more / read less ---------- */

      toggleReadMore(btn) {
        var panel = btn.closest('[data-content]');
        if (!panel) return;
        var open = panel.classList.toggle('is-open');
        btn.textContent = open ? (this.dataset.readLess || 'Read Less') : (this.dataset.readMore || 'Read More');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      // Hide the button when a panel's text already fits on one line.
      // Only visible panels can be measured, so this re-runs on tab switch and resize.
      checkReadMore() {
        this.querySelectorAll('[data-content]').forEach(function (panel) {
          var clamp = panel.querySelector('[data-clamp]');
          var btn = panel.querySelector('[data-readmore]');
          if (!clamp || !btn || panel.classList.contains('is-open') || !panel.offsetParent) return;
          btn.hidden = clamp.scrollHeight <= clamp.clientHeight + 1;
        });
      }

      /* ---------- Quantity + tiers ---------- */

      readTier(btn) {
        var bd = btn.dataset;
        this.quantity = parseInt(bd.tierQty, 10) || 1;            // bottles in the pack (display + days)
        this.cartQty = parseInt(bd.cartQty, 10) || this.quantity; // units actually added to the cart
        this.variantId = bd.variantId || null;
        this.tierPrice = parseInt(bd.tierPrice, 10);
        this.tierAvailable = bd.available !== 'false';
        this.discount = parseFloat(bd.tierDiscount) || 0;
        this.totalDays = parseInt(bd.tierTotalDays, 10) || this.quantity * this.daysPerUnit;
      }

      selectTier(btn) {
        if (!this.tiersEnabled) return;
        this.readTier(btn);
        this.tierList.querySelectorAll('[data-tier-option]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        this.updatePrice();
      }

      step(delta) {
        if (this.tiersEnabled || !this.qtyInput) return;
        this.quantity = Math.max(1, this.quantity + delta);
        this.totalDays = this.quantity * this.daysPerUnit;
        this.updatePrice();
      }

      updatePrice() {
        if (this.qtyInput) this.qtyInput.value = this.quantity;

        var total;
        if (this.tiersEnabled && !isNaN(this.tierPrice)) {
          total = this.tierPrice;
        } else {
          total = this.basePrice * this.quantity;
          if (this.discount > 0) total = Math.round(total * (1 - this.discount / 100));
        }

        if (this.tiersEnabled && this.atcBtn) {
          var avail = this.tierAvailable;
          if (this.variantId) this.atcBtn.dataset.productId = this.variantId;
          this.atcBtn.disabled = !avail;
          if (this.atcLabel) this.atcLabel.textContent = avail ? (this.dataset.atcText || '') : (this.dataset.soldOutText || '');
          if (this.atcPriceEl) this.atcPriceEl.hidden = !avail;
          if (this.atcPerDayEl) this.atcPerDayEl.hidden = !avail;
        }

        if (this.atcPriceEl) this.atcPriceEl.textContent = this.formatMoney(total);
        if (this.showPerDay && this.atcPerDayEl) {
          var days = this.totalDays || this.quantity * this.daysPerUnit || 1;
          this.atcPerDayEl.textContent = this.formatMoney(Math.round(total / days)) + '/' + this.perDayLabel;
        }
      }

      formatMoney(cents) {
        var match = this.moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
        var opt = MONEY_FORMATS[match ? match[1] : 'amount'] || MONEY_FORMATS.amount;
        var parts = (cents / 100).toFixed(opt[0]).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, opt[1]);
        var value = parts.join(opt[2]);
        return match ? this.moneyFormat.replace(match[0], value) : value;
      }

      /* ---------- Add to cart ---------- */

      addToCart(e) {
        // No stopPropagation: apps like GoKwik listen for this click on document.
        e.preventDefault();
        var btn = this.atcBtn;
        if (!btn || btn.disabled) return;

        var id = btn.dataset.productId;
        var qty = this.quantity;
        if (this.tiersEnabled && this.tierList) {
          var sel = this.tierList.querySelector('[data-tier-option].selected');
          if (sel) this.readTier(sel);
          id = this.variantId || id;
          qty = this.cartQty;
        } else if (this.qtyInput) {
          qty = parseInt(this.qtyInput.value, 10) || qty;
        }
        qty = Math.max(1, qty);

        var label = this.atcLabel;
        var labelText = label ? label.textContent : '';
        btn.disabled = true;
        if (label) label.textContent = this.dataset.addingText || labelText;

        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        this.cartRoot = root;

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: qty })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (data) {
                throw new Error((data && data.description) || 'Could not add item to cart');
              });
            }
            return this.openCart();
          }.bind(this))
          .catch(function (err) { console.error('Add to cart error:', err); })
          .then(function () {
            btn.disabled = false;
            if (label) label.textContent = labelText;
          });
      }

      /* ---------- Cart drawer ---------- */

      openCart() {
        if (!this.cartOverlay) return Promise.resolve();
        this.cartOverlay.classList.add('active');
        this.lock();

        return fetch((this.cartRoot || '/') + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(this.renderCart.bind(this))
          .catch(function (err) {
            console.error('Could not load cart contents:', err);
            if (this.cartBody) this.cartBody.innerHTML = '<div class="aipo__cart-msg">' + esc(this.dataset.errorText) + '</div>';
          }.bind(this));
      }

      closeCart() {
        if (!this.cartOverlay || !this.cartOverlay.classList.contains('active')) return;
        this.cartOverlay.classList.remove('active');
        this.unlock();
      }

      renderCart(cart) {
        if (!this.cartBody) return;
        if (this.cartSubtotal) this.cartSubtotal.textContent = this.formatMoney(cart.total_price);

        if (!cart.items || !cart.items.length) {
          this.cartBody.innerHTML = '<div class="aipo__cart-msg">' + esc(this.dataset.emptyText) + '</div>';
          return;
        }

        var self = this;
        this.cartBody.innerHTML = cart.items.map(function (item) {
          var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=128' : '';
          var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          return '<div class="aipo__cart-item">' +
            (img
              ? '<img class="aipo__cart-item-image" src="' + esc(img) + '" alt="' + esc(item.product_title) + '" width="64" height="64" decoding="async">'
              : '<div class="aipo__cart-item-image"></div>') +
            '<div class="aipo__cart-item-info">' +
              '<div class="aipo__cart-item-title">' + esc(item.product_title) + '</div>' +
              (variant ? '<div class="aipo__cart-item-variant">' + esc(variant) + '</div>' : '') +
              '<div class="aipo__cart-item-qty">Qty ' + item.quantity + ' · ' + esc(self.formatMoney(item.final_line_price)) + '</div>' +
            '</div>' +
          '</div>';
        }).join('');
      }

      /* ---------- Reviews scroll ---------- */

      scrollToReviews(e) {
        if (e && e.target && e.target.closest('a')) return; // let Judge.me's own link handle it
        var el = this.querySelector('[data-rating]');
        var anchor = el ? el.dataset.reviewsAnchor : '';
        var selectors = anchor ? ['#' + anchor, '.' + anchor].concat(REVIEW_SELECTORS) : REVIEW_SELECTORS;
        for (var i = 0; i < selectors.length; i++) {
          var target = null;
          try { target = document.querySelector(selectors[i]); } catch (err) {}
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }
        }
        console.warn('Reviews section not found on this page. Set the correct ID in block settings.');
      }

      /* ---------- Scroll lock + Escape (only attached while something is open) ---------- */

      lock() {
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this.onEsc);
      }

      unlock() {
        var zoomOpen = this.zoom && this.zoom.classList.contains('active');
        var cartOpen = this.cartOverlay && this.cartOverlay.classList.contains('active');
        if (zoomOpen || cartOpen) return;
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this.onEsc);
      }

      onEsc(e) {
        if (e.key !== 'Escape') return;
        this.closeZoom();
        this.closeCart();
      }
    }

    customElements.define('aipo-product-overview', AipoProductOverview);
  })();
  } catch(e) { console.error(e); }
})();

})();
